import React from "react";
import { Input, Select } from "../";

export interface FilterConfig {
  key: string;
  type: "text" | "select" | "multiselect" | "date";
  label: string;
  placeholder?: string;
  options?: Array<{ value: string; label: string }>;
  className?: string;
}

export interface FilterItemProps {
  config: FilterConfig;
  value: unknown;
  onChange: (_value: unknown) => void;
  showLabel?: boolean;
}

const FilterItem: React.FC<FilterItemProps> = ({ config, value, onChange, showLabel = true }) => {
  // value is unknown (the filter value type is caller-defined); coerce to string for inputs.
  const stringValue = value == null ? "" : String(value);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    onChange(e.target.value);
  };

  const handleMultiSelectChange = (selectedValues: string[]) => {
    onChange(selectedValues);
  };

  const renderInput = () => {
    switch (config.type) {
      case "text":
        return (
          <Input
            type="text"
            placeholder={config.placeholder || config.label}
            value={stringValue}
            onChange={handleChange}
            variant="filled"
            size="md"
            className={config.className || "w-full"}
            aria-label={config.label}
          />
        );

      case "select":
        return (
          <Select
            value={stringValue}
            onChange={handleChange}
            options={config.options || []}
            variant="filled"
            size="md"
            className={config.className || "w-full"}
            aria-label={config.label}
          />
        );

      case "date":
        return (
          <Input
            type="date"
            placeholder={config.placeholder || config.label}
            value={stringValue}
            onChange={handleChange}
            variant="filled"
            size="md"
            className={config.className || "w-full"}
            aria-label={config.label}
          />
        );

      case "multiselect":
        // For now, implement as a regular select - can be enhanced later
        return (
          <Select
            value={Array.isArray(value) ? value.join(",") : stringValue}
            onChange={(e) => {
              const values = e.target.value ? e.target.value.split(",") : [];
              handleMultiSelectChange(values);
            }}
            options={config.options || []}
            variant="filled"
            size="md"
            className={config.className || "w-full"}
            aria-label={config.label}
          />
        );

      default:
        return null;
    }
  };

  return (
    <div className="w-full">
      {showLabel && config.label && (
        <label className="block text-xs text-zinc-400 mb-1.5 font-medium">{config.label}</label>
      )}
      {renderInput()}
    </div>
  );
};

export default FilterItem;
